import { render } from "./userShoppingView.vue?vue&type=template&id=06f6c825&scoped=true"
import script from "./userShoppingView.vue?vue&type=script&lang=js"
export * from "./userShoppingView.vue?vue&type=script&lang=js"

import "./userShoppingView.vue?vue&type=style&index=0&id=06f6c825&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06f6c825"

export default script